import React from 'react';
export function ProofSection() {
  return <section className="py-24 bg-stone-900 text-stone-50" data-id="element-174">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-177">
            What Changes in 48 Hours
          </h2>
          <p className="text-lg text-stone-400" data-id="element-178">
            The biological timeline of your reset.
          </p>
        </div>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-forest-500 before:to-transparent" data-id="element-179">
          {/* Hour 12 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-180">
            <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-stone-900 bg-forest-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-181">
              <span className="text-xs font-bold" data-id="element-182">12h</span>
            </div>
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-stone-800 p-6 rounded-xl border border-stone-700 shadow-sm" data-id="element-183">
              <h3 className="font-serif text-xl text-white mb-2" data-id="element-184">
                The Release
              </h3>
              <p className="text-stone-300 leading-relaxed" data-id="element-185">
                The "tightness" in your midsection begins to release as the
                digestive pause takes effect.
              </p>
            </div>
          </div>

          {/* Hour 24 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-186">
            <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-stone-900 bg-forest-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-187">
              <span className="text-xs font-bold" data-id="element-188">24h</span>
            </div>
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-stone-800 p-6 rounded-xl border border-stone-700 shadow-sm" data-id="element-189">
              <h3 className="font-serif text-xl text-white mb-2" data-id="element-190">The Flush</h3>
              <p className="text-stone-300 leading-relaxed" data-id="element-191">
                Your face looks noticeably less puffy and your energy stabilizes
                as the osmotic flush clears retained water.
              </p>
            </div>
          </div>

          {/* Hour 48 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-192">
            <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-stone-900 bg-forest-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-193">
              <span className="text-xs font-bold" data-id="element-194">48h</span>
            </div>
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-stone-800 p-6 rounded-xl border border-forest-700 shadow-sm relative overflow-hidden" data-id="element-195">
              <div className="absolute top-0 right-0 w-16 h-16 bg-forest-500/20 rounded-bl-full" data-id="element-196"></div>
              <h3 className="font-serif text-xl text-white mb-2" data-id="element-197">The Reset</h3>
              <p className="text-stone-300 leading-relaxed" data-id="element-198">
                Your digestive system has completed a full mechanical reset. You
                feel 3-5 lbs lighter, completely de-bloated, and ready for your
                event.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}